import { Button, Icon } from "@mui/material";
import React, { CSSProperties, FC, useEffect } from "react";
import "./style.css"

export interface BottomBarInterface {
    disableElevation?: boolean
    expanded?: boolean
}

const BottomBar: FC<BottomBarInterface> = ({
    disableElevation = false,
    expanded = true,
    children
}) => {
    const [checked, setChecked] = React.useState(expanded);

    useEffect(() => {
        setChecked(expanded)
    }, [expanded]);

    const containerCss: CSSProperties = {
        display: "inline-flex",
        flexDirection: "row",
        padding: "10px",
        right: "30px",
        zIndex: 2,
        bottom: "10px",
        backgroundColor: "#fff",
        margin: "0 auto",
        position: "fixed",
        // minWidth: "5vw",
        borderRadius: "4px",
        boxShadow: disableElevation ? "none" : "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
        justifyContent: "flex-end"
    }

    const itemCss: CSSProperties = {
        minHeight: "30px",
        display: "flex",
        margin: "4px",
    }

    const handleChange = () => {
        setChecked((prev) => !prev);
    };

    return (
        <section style={containerCss}>
            <div className="row X--end">
                <div style={{ width: checked ? "auto" : "0px", display: checked ? "inherit" : "none" }}>
                    {React.Children.map(children, (item: any, index: number) => {
                        return <div style={itemCss} key={`item-${index}`}>{item}</div>

                    })}
                </div>
                <div style={itemCss}>
                    <Button onClick={handleChange} size="small" variant="text">
                        <Icon>{checked ? "arrow_right" : "arrow_left"}</Icon>
                    </Button>
                </div>
            </div>
        </section>
    )
}

export { BottomBar }